(function () {
  const POLL_MS = 5000;
  let intervalId = null;

  function pendingNodes() {
    return $j(".encoding-pending[data-asset-hash]");
  }

  function startPoller() {
    if (intervalId) return; // already running
    if (pendingNodes().length === 0) return; // nothing to do

    intervalId = setInterval(tick, POLL_MS);
    tick(); // optional: run immediately once
  }

  function stopPoller() {
    if (!intervalId) return;
    clearInterval(intervalId);
    intervalId = null;
  }

  function tick() {
    const nodes = pendingNodes();
    if (nodes.length === 0) {
      stopPoller();
      return;
    }

    const hashes = nodes
      .map(function () { return $j(this).data("asset-hash"); })
      .get();

    // De-dupe
    const uniq = Array.from(new Set(hashes));
    if (uniq.length === 0) return;

    // If you stored a data-check-url on the first node:
    const url = $j(nodes[0]).data("check-url");

    $j.ajax({
      url: url,
      method: "GET",
      dataType: "json",
      data: { post_asset_ids: uniq, v: Math.round(new Date().getTime()/1000) }
    }).done(function (payload) {
      // Expecting: { ready: [{hash: "...", html: "..."}] }
      if (!payload || !payload.ready) return;

      payload.ready.forEach(function (item) {
        const selector = "#diamond-video-content-" + item.hash;
        const el = $j(selector);
        if (el.length === 0) return;

        el.replaceWith(item.html);
      });

      if (payload.ready.length > 0) {
        initVideo();
      }

      // If everything is done, stop.
      if (pendingNodes().length === 0) stopPoller();
    });
  }

  // Hook it up. If you use Turbo, swap this for turbo:load.
  $j(document).on("ready", startPoller);
  // If Turbo is in play:
  document.addEventListener("turbo:load", startPoller);
})();